<accordion>
  <accordion-panel>
    <div panel-header>Rendering</div>
    <label>
      Renderer Type
      <select [(ngModel)]="componentData.config.rendererType">
        @for (type of rendererTypes; track type) {
          <option [value]="type">{{type}}</option>
        }
      </select>
    </label>
  </accordion-panel>
  <accordion-panel>
    <div panel-header>Camera</div>
    <div class="grid-x">
      <label class="cell small-12">
        Zoom
        <input type="text" [(ngModel)]="componentData.config.properties.zoom" />
      </label>
      <h4>Center</h4>
      <label class="cell small-12">
        Latitude (Context Location)
        <input type="text" [(ngModel)]="componentData.config.contextLocations.latitude" />
      </label>
      <label class="cell small-12">
        Longitude (Context Location)
        <input type="text" [(ngModel)]="componentData.config.contextLocations.longitude" />
      </label>
    </div>
  </accordion-panel>
  <accordion-panel>
    <div panel-header>Layers</div>
    <layer-manager [config]="componentData.config"></layer-manager>
  </accordion-panel>
  <accordion-panel>
    <div panel-header>Geometry</div>
    <geometry-manager [config]="componentData.config"></geometry-manager>
  </accordion-panel>
  <accordion-panel>
    <div panel-header>Widgets</div>
    <widget-manager [config]="componentData.config"></widget-manager>
  </accordion-panel>
</accordion>
